import '@common/reset.css'
import './style.scss'
import { useEffect, useState } from 'react'
import Header from './components/Header'
import AutorSection from './components/AutorSection'
import HeaderEmbed from '@common/HeaderEmbed'

export default function App({ preview, year }) {
	if (!year) return null
	const [data, setData] = useState(null)

	useEffect(() => {
		fetch(`${process.env.API_CLIENT}/firmessantjordi/v1/${year}`)
			.then((res) => res.json())
			.then((json) => setData(json))
			.catch((error) => console.log(error))
	}, [])

	if (!data) return null

	return (
		<>
			{preview && <HeaderEmbed />}
			<Header year={year} />
			<AutorSection data={data} />
		</>
	)
}
